import React from 'react';
import {useSalesforceLeadFieldQuery} from 'api';
import useSearchParams from '../../../../../useSearchParams';
import {Listbox} from '@headlessui/react';
import ArrowDownIcon from './ArrowDownIcon';

type CustomizeItemFilterItem = {
  salesforceLeadFieldId: string;
  customizeItemValue: string;
  index: number;
};

export default ({
  salesforceLeadFieldId,
  customizeItemValue,
  index,
}: CustomizeItemFilterItem) => {
  const {query, setQuery} = useSearchParams();
  const {data: {salesforceLeadField = {}} = {}} = useSalesforceLeadFieldQuery({
    variables: {leadFieldId: salesforceLeadFieldId},
    skip: !salesforceLeadFieldId,
  });

  const customizeItemOptions = () => {
    return salesforceLeadField?.salesforceLeadFieldSelectOptions || [];
  };

  const selectedItemName = (): string => {
    return (salesforceLeadField?.salesforceLeadFieldSelectOptions || [])?.find(
      (option) => customizeItemValue === option.id,
    )?.label;
  };

  if (!salesforceLeadFieldId) {
    return <></>;
  }

  return (
    <div className="relative">
      <Listbox
        value={customizeItemValue ?? ''}
        disabled={!salesforceLeadField}
        onChange={(value) => {
          setQuery({
            ...query,
            salesforceLeadSearchConditions: [
              ...query.salesforceLeadSearchConditions.slice(0, index),
              {
                lead_field_id: salesforceLeadField.id,
                field_type: 'select',
                field_select_option_id: value,
              },
              ...query.salesforceLeadSearchConditions.slice(index + 1),
            ],
          });
        }}>
        <Listbox.Button className="relative px-3 text-left focus:outline-none flex items-center border rounded w-80 min-h-8 h-full bg-white border-[#d9d9d9] justify-between py-1">
          <div className="flex gap-1 min-h-8 w-auto flex-wrap">
            <div key={index} className="bg-[#F3F5F7] px-1">
              {selectedItemName()}
            </div>
          </div>
          <ArrowDownIcon />
        </Listbox.Button>
        <Listbox.Options className="absolute">
          {customizeItemOptions().map((customizeItemOption) => (
            <Listbox.Option
              className={({active}) =>
                `relative select-none py-2 px-3 cursor-pointer w-80 h-8 pr-10 z-20 truncate ${
                  active ? 'bg-gray-100' : 'bg-white'
                }`
              }
              key={customizeItemOption.id}
              value={customizeItemOption.id}>
              {customizeItemOption.label}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </Listbox>
    </div>
  );
};
